import { type Immutable } from 'immer';
import { type ServiceDisplayWidget } from '../../layout/types';
import { type WidgetFormData } from '../WidgetDialog/schema';

type WidgetInput =
  WidgetFormData | Readonly<ServiceDisplayWidget> | Immutable<ServiceDisplayWidget>;

/**
 * Extract standardized analytics properties from any widget data structure.
 * Handles both form data and existing widgets consistently.
 */
export function getWidgetAnalytics(input: WidgetInput, assignedTag: string | undefined) {
  // Determine if input is form data or widget
  const isFormData = 'title' in input && !('config' in input);

  const widgetType = isFormData ? input.type : input.config.type;
  const title = input.title;
  const tagCount = input.tagIds.length;

  // Common properties
  const analytics = {
    widgetTitle: title,
    widgetType,
    tagCount,
    assignedTag,
  };

  // Type-specific properties
  if (widgetType === 'COUNT') {
    if (isFormData && input.type === 'COUNT') {
      return {
        ...analytics,
        horizon: input.horizon,
        countThreshold: input.countThreshold,
      };
    }
    if (!isFormData && input.config.type === 'COUNT') {
      return {
        ...analytics,
        horizon: input.config.horizon,
        countThreshold: input.config.threshold,
      };
    }
  }

  if (widgetType === 'TIME' || widgetType === 'TOTAL_JOURNEY_TIME') {
    if (isFormData && (input.type === 'TIME' || input.type === 'TOTAL_JOURNEY_TIME')) {
      const fallBackTimeThreshold = `${input.timeThresholdMinutes ?? 0} m ${input.timeThresholdSeconds ?? 0} s`;

      return {
        ...analytics,
        horizon: input.horizon,
        fallBackTimeThreshold,
      };
    }
    if (
      !isFormData &&
      (input.config.type === 'TIME' || input.config.type === 'TOTAL_JOURNEY_TIME')
    ) {
      return {
        ...analytics,
        horizon: input.config.horizon,
        fallBackTimeThreshold: `${Math.floor(input.config.threshold / 60)} m ${input.config.threshold % 60} s`,
      };
    }
  }

  return analytics;
}
